/**
 * Top-level model that maintains a list of available Datasets ({@link #_availableDatasets}), and a
 * pointer to the currently active Dataset ({@link #_activeDataset}). Updating the currently active
 * Dataset is done via the {@link #setActiveDataset()} method, which results in an
 * {@link #VALUE_CHANGED_EVENT} event being emitted with a reference to the
 * {@link #_activeDataset}.
 */
import EventEmitter from 'events';

export default class DatasetsModel extends EventEmitter {

  /**
   * Constructor to cache the list of available Datasets and select the default active Dataset.
   */
  constructor(datasets) {
    super();

    // Cache references.
    this._availableDatasets = datasets;

    // Build the 'variable' property for MSP1 datasets.
    this._availableDatasets.forEach(dataset => {
      if (dataset.type === 'msp1') {
        dataset.variables.forEach(variable => {
          // Find the further details in dataset.fields.
          const field = dataset.fields.find(field => {
            return field.id === variable.fieldId;
          });
          if (field) {
            variable.isNumerical = field.type === 'numerical';
            variable.fieldName = field.fieldName;
          }

        });
      }
    });

    // Select the first Dataset as the default.
    this._activeDataset = (this._availableDatasets.length > 0 ? this._availableDatasets[0] : null);

    // Define the events fired by this model.
    this.VALUE_CHANGED_EVENT = 'app.dataset.change';

  }

  /**
   * Initialise the model and emit an {@link #VALUE_CHANGED_EVENT}.
   */
  init() {

    // Build the 'variable' property for MSP1 datasets.
    this._availableDatasets.forEach(dataset => {
      if (dataset.type === 'msp1') {
        dataset.variables.forEach(variable => {
          // Find the further details in dataset.fields.
          const field = dataset.fields.find(field => {
            return field.id === variable.fieldId;
          });
          if (field) {
            variable.isNumerical = field.type === 'numerical';
            variable.fieldName = field.fieldName;
          }

        });
      }
    });

    this.emit(this.VALUE_CHANGED_EVENT, this._activeDataset);
  }

  getAvailableDatasets() {
    return this._availableDatasets;
  }

  /**
   * Getter for the 'active' Dataset.
   */
  getActiveDataset() {
    return this._activeDataset;
  }

  /**
   * Setter for the 'active' Dataset. Ensure the specified Dataset is not the current Dataset, and
   * is in the list of available Datasets.
   */
  setActiveDataset(dataset) {
    if (!this._activeDataset || this._activeDataset.id != dataset.id) {
      if (this._availableDatasets.some((d) => d.id == dataset.id)) {
        this._activeDataset = dataset;
        this.emit(this.VALUE_CHANGED_EVENT, this._activeDataset);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/models/datasets-model.js